import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Button, ButtonElement, ButtonProps } from '../Button/index.js';

export type ToggleButtonElement = ButtonElement;
export interface ToggleButtonProps extends ButtonProps {
  actived?: boolean;
}

export const ToggleButton = styled(
  forwardRef<ToggleButtonElement, ToggleButtonProps>(({ actived, ...restProps }, ref) => (
    <Button ref={ref} {...restProps} color={actived ? 'primary' : restProps.color} />
  ))
).withConfig({
  displayName: 'ToggleButton',
})``;
